// extracted by mini-css-extract-plugin
export default {"header":"invite-course_header__7-ClQ","body":"invite-course_body__QHKhE","highlighter":"invite-course_highlighter__CXoTx"};